import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-status-wise-average-time',
  templateUrl: './status-wise-average-time.component.html',
  styleUrls: ['./status-wise-average-time.component.css']
})
export class StatusWiseAverageTimeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
